import { cn } from "@/lib/utils";

export const BRAND_WORDMARK = "Davor AI";

type WordmarkProps = {
  className?: string;
  /** White wordmark for dark brand panels. */
  tone?: "default" | "inverse";
  alt?: string;
};

export function Wordmark({
  className,
  tone = "default",
  alt = BRAND_WORDMARK,
}: WordmarkProps) {
  return (
    <img
      src="/icon.svg"
      alt={alt}
      width={872}
      height={210}
      className={cn(
        "h-8 w-auto max-w-full shrink-0 self-start",
        tone === "inverse" ? "invert" : "dark:invert",
        className,
      )}
    />
  );
}
